import { get, post, remove } from '~/services/http-requests'

const _BS_USERS = 'profiles'
const _BS_OWN_PROFILE = 'own_profile'

enum UserGroups {
    Admin = 1,
    Uploader = 2,
    Producer = 3
}

/*
 **** GET ****
 */
async function fetchOwnProfile(): Promise<IUser> {
    const fullUrl = process.env.VUE_APP_DASHBOARD ? `${_BS_OWN_PROFILE}.json?include[]=total_sales` : _BS_OWN_PROFILE
    const [first] = await get({ baseProperty: _BS_USERS, fullUrl })
    return first
}

function fetchUsers(): Promise<IUser[]> {
    return get({ baseProperty: _BS_USERS })
}

function fetchCustomers(): Promise<IUser[]> {
    return get({ baseProperty: _BS_USERS, fullUrl: `${_BS_USERS}.json?filter{total_spent.gt}=0` })
}

function fetchAdminUsers(): Promise<IUser[]> {
    return get({ baseProperty: _BS_USERS, fullUrl: `${_BS_USERS}.json?filter{groups.in}=${UserGroups.Admin}&filter{groups.in}=${UserGroups.Uploader}` })
}

async function fetchUsersWithSearch(stringToMatch: string): Promise<IUser[]> {
    const responseName: IUser[] = await get({
        baseProperty: _BS_USERS,
        fullUrl: `${_BS_USERS}.json?filter{first_name.icontains}=${stringToMatch}`
    })
    const responseEmail: IUser[] = await get({
        baseProperty: _BS_USERS,
        fullUrl: `${_BS_USERS}.json?filter{email.icontains}=${stringToMatch}`
    })
    const finalResponse: IUser[] = Object.values(
        responseName.concat(responseEmail).reduce((previous: { [id: number]: IUser }, current: IUser) => {
            previous[current.id] = current
            return previous
        }, {})
    )
    return finalResponse
}

/*
 **** POST ****
 */
function signupProducer(producerToSignup: IProducerToSignup) {
    return post({ baseProperty: 'add_new_dashboard_user/', dispatchParams: producerToSignup })
}

/*
 **** DELETE ****
 */
function removeUser(userId: IUser['id']): Promise<IUser[]> {
    return remove({ baseProperty: _BS_USERS, fullUrl: `${_BS_USERS}/${userId}` })
}

export { fetchOwnProfile, fetchUsers, fetchCustomers, fetchAdminUsers, fetchUsersWithSearch, signupProducer, removeUser }
